import React from "react";
const GenericBanner = ({
	iconSrc,
	title,
	subtitle,
	description,
	bgColor = "#D2DCD1",
	containerWidth = "w-[1256px]",
	iconSize = { width: "w-[58px]", height: "h-[64px]" },
	className = "",
	marginTop = "mt-[20px]",
	width = "xl:w-[90%]",
}) => {
	return (
		<div
			className={`flex flex-col h-[280px] ${width}   mx-auto  ${bgColor} ${marginTop} hidden lg:flex ${className}`}
		>
			{/* Icon centered */}
			<div className="flex-1 flex items-center justify-center">
				<img
					loading="lazy"
					decoding="async"
					src={iconSrc}
					alt="Icon"
					className={`${iconSize.width} ${iconSize.height} object-contain`}
				/>
			</div>

			{/* Text Block */}
			<div className="w-[948px] pr-[16px] pb-[16px] pl-[16px] gap-[8px] flex flex-col">
				<p className="font-[Montserrat] font-semibold text-[32px] leading-[32px] text-[#193D34]">
					{title}
				</p>
				<p className="font-[Montserrat] font-normal text-[14px] leading-[14px] text-[#7A7A7A]">
					{subtitle}
				</p>
				<p className="font-[Montserrat] font-normal text-[14px] leading-[14px] text-[#7A7A7A] whitespace-pre-line">
					{Array.isArray(description)
						? description.map((part, i) => (
								<React.Fragment key={i}>{part}</React.Fragment>
							))
						: description}
				</p>
			</div>
		</div>
	);
};

export default GenericBanner;
